
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-compositions/[[...slug]]",
      function () {
        return require("private-next-pages/team-compositions/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-compositions/[[...slug]]"])
      });
    }
  